import { parseProperties } from 'Services/ActionProperties';

angular.module('services.actionProperties', []).service('ActionProperties', function () {
	var instance = {};

	instance.parse = (target, properties, arrayProperties) => {
		const parsed = parseProperties(properties, arrayProperties);
		Object.keys(parsed).reduce((result, name) => {
			result[name] = parsed[name];
			return result;
		}, target);
	};

	instance.parseCustomFields = function (availableFields, target, properties, entity, dateTypes) {
		angular.forEach(availableFields, function (field) {
			var key = entity + '.custom_' + field.id.toString();
			if (properties[key] !== undefined) {
				field.value = properties[key];
				if (field.datatype === 'Boolean') {
					// If field.value is truthy, make it true. If it is falsey, make it false.
					if (field.value === '0') {
						field.value = false;
					}
					if (field.value === '1') {
						field.value = true;
					}
					field.value = !!field.value;
				} else if (field.datatype === 'Date' && dateTypes) {
					var found = _.find(dateTypes, function (type) {
						return field.value.indexOf(type.tag) !== -1;
					});
					field.value = found;
				} else if (field.datatype === 'Users') {
					field.value = window.Tools.AppService.getActiveUsers()
						.filter(function (user) {
							return field.value.split(',').includes(String(user.id));
						})
						.map(function (user) {
							return { id: user.id, text: user.name };
						});
				}

				target.push(field);
			}
			// Remove field from properties
			delete properties[entity + '.custom_' + field.id.toString()];
		});

		_.each(target, function (field) {
			_.remove(availableFields, { id: field.id });
		});
	};

	instance.getCustomFieldValue = function (field) {
		if (!field.value) {
			return null;
		}

		if (field.datatype === 'Users' && Array.isArray(field.value)) {
			if (field.value.length) {
				field.value = field.value
					.map(function (value) {
						return value.id;
					})
					.join(',');
			} else {
				field.value = null;
			}
		} else if (field.datatype === 'User' && field.value.id) {
			field.value = String(field.value.id);
		}

		return field.value;
	};

	return instance;
});
